import React, {useEffect, useRef, useState} from 'react';
import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';
import PropTypes from "prop-types";
import AdminUserRow from "./adminUserRow";
import CustomPaginator from "../../components/paginator";

const RESULTS_PER_PAGE = 100;

const AdminUsersList = ({setLoading, setError}) => {
  const [sortBy, setSortBy] = useState(null);
  const [users, setUsers] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [totalCount, setTotalCount] = useState(null);

  const [typedQuery, setTypedQuery] = useState(null); // for detecting input change
  const [query, setQuery] = useState(null); // for triggering actual search
  const queryTimer = useRef(null);

  useEffect(() => {
    clearTimeout(queryTimer.current)
    queryTimer.current = setTimeout(() => {
      setQuery(typedQuery);
    },1000)

  },[typedQuery])

  useEffect(() => {
    getUsers();
  }, [query]);

  function getUsers(newSortParam, newActivePage) {
    const pageNumber = newActivePage || activePage;

    setLoading(true);
    apiCalls.getUsersAdmin({
      query,
      sortBy: newSortParam || sortBy,
      max: RESULTS_PER_PAGE,
      offset: (pageNumber - 1) * RESULTS_PER_PAGE,
    })
      .then((result) => {
        setUsers(result.data.users);
        setTotalCount(result.data.totalCount);
        setLoading(false);
      }).catch((errors) => {
      setLoading(false);
      setError(utils.getErrorMessageFromResponse(errors));
    });
  }
  
  function setSortMethod(newSortBy) {
    let sortParam;

    switch (newSortBy) {
      case 'screenName':
        sortParam = sortBy === 'screenNameAsc'? 'screenNameDesc': 'screenNameAsc';
        break;
      case 'firstName':
        sortParam = sortBy === 'firstNameAsc'? 'firstNameDesc': 'firstNameAsc';
        break;
      case 'lastName':
        sortParam = sortBy === 'lastNameAsc'? 'lastNameDesc': 'lastNameAsc';
        break;
      case 'email':
        sortParam = sortBy === 'emailAsc'? 'emailDesc': 'emailAsc';
        break;
      case 'contact':
        sortParam = sortBy === 'contactAsc'? 'contactDesc': 'contactAsc';
        break;
      case 'dateCreated':
        sortParam = sortBy === 'dateCreatedAsc'? 'dateCreatedDesc': 'dateCreatedAsc';
        break;
      case 'id':
      default:
        sortParam = sortBy === 'idAsc'? 'idDesc': 'idAsc';
    }
    
    setSortBy(sortParam);
    getUsers(sortParam);
  }

  function onPageSelect(newNumber) {
    if (newNumber !== activePage) {
      setActivePage(newNumber);
      getUsers(undefined, newNumber);
    }
  }

  return (
    <div>
      <div className="m-b-3 m-t-3">
        <CustomPaginator activePage={activePage}
                         resultsPerPage={RESULTS_PER_PAGE}
                         setActivePage={onPageSelect}
                         totalCount={totalCount}/>
      </div>

      <div className="text-right">
        <div className="form-group field field-string d-inline-block">
          <input className="form-control" placeholder="Search"
                 type="text"  value={typedQuery}
                 onChange={(e) => setTypedQuery(e.target.value)}/>
        </div>
      </div>

      <table className="table table-striped admin__table">
        <thead>
        <tr>
          <th onClick={() => setSortMethod('id')} className="sortable" scope="col">Id</th>
          <th scope="col">
            <i className="fa fa-image"/>
          </th>
          <th onClick={() => setSortMethod('screenName')} className="sortable" scope="col">Screen name</th>
          <th onClick={() => setSortMethod('contact')} className="sortable" scope="col">Contact</th>
          <th scope="col">Phone number</th>
          <th onClick={() => setSortMethod('dateCreated')} className="sortable" scope="col">Date created</th>
          <th className="sortable" scope="col">Attribution</th>
          <th scope="col">Actions</th>
        </tr>
        </thead>
        <tbody>

        {
          users.map((user, index) => (
          <AdminUserRow user={user} key={index}/>
          ))
        }
        </tbody>
      </table>

      <div className="m-b-6">
        <CustomPaginator activePage={activePage}
                         resultsPerPage={RESULTS_PER_PAGE}
                         setActivePage={onPageSelect}
                         totalCount={totalCount}/>
      </div>
    </div>
  );
};

AdminUsersList.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminUsersList.defaultProps = {};

export default AdminUsersList;
